import {
  IMPROVED_GROUP_VIEW_FEATURE_FLAG,
  RenderIfFFEnabled,
} from 'featureFlags';
import { MenuRoot, MenuContent, MenuTrigger, ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { useToggle } from 'usehooks-ts';

import {
  GoalMenuEditButton,
  GoalMenuDeleteButton,
  useEditGoal,
} from 'features/goal';
import { useGoalCardContext } from 'features/goal/context/cardContext';
import { usePrioritizeToggleOnBoard } from 'features/goal/hooks/usePrioritizeToggleOnBoard';

import { GoalCardMenuPrioritizeButton } from './Menu/PrioritizeButton';

export const GoalCardMenu = () => {
  const [open, toggleOpen] = useToggle(false);
  const { goal } = useGoalCardContext();
  const { goalId, prioritizedAt, columnId } = goal;

  const { onEditGoalClick } = useEditGoal({ goal });

  const togglePrioritizeOnBoard = usePrioritizeToggleOnBoard();

  return (
    <MenuRoot
      open={open}
      closeOnSelect
      onOpenChange={(details: { open: boolean }) => {
        if (details.open !== open) {
          toggleOpen();
        }
      }}
    >
      <MenuTrigger asChild>
        <ButtonIcon
          aria-label="goal card menu"
          variant="ghost"
          size="2xs"
          onClick={(evt) => {
            evt.preventDefault();
            toggleOpen();
          }}
        >
          <Icon name={iconNames.ellipsisHorizontal} />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent py="1px" overflow="hidden">
        <GoalMenuEditButton onClick={onEditGoalClick} />
        <RenderIfFFEnabled featureFlag={IMPROVED_GROUP_VIEW_FEATURE_FLAG}>
          <GoalCardMenuPrioritizeButton
            goalId={goalId}
            prioritizedAt={prioritizedAt}
            columnId={columnId}
            togglePrioritize={togglePrioritizeOnBoard}
          />
        </RenderIfFFEnabled>
        <GoalMenuDeleteButton goalId={goalId} columnId={columnId} />
      </MenuContent>
    </MenuRoot>
  );
};
